import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'ui-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: ` {{ value() }} `,
  host: {
    class: 'bg-foreground w-fit max-w-xs text-background rounded-xl px-3 py-1.5 text-xs',
    '[animate.enter]': '"animate-fade-in"'
  }
})
export class Tooltip {
  // Signals
  readonly value = signal<string | null | undefined>('');
}
